import { EventEmitter, Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { ACTIVE_THEME, Theme, THEMES } from './symbols';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    themeChange = new EventEmitter<Theme>();

    constructor(
        @Inject(THEMES) public themes: Theme[],
        @Inject(ACTIVE_THEME) public theme: string,
        @Inject(DOCUMENT) private document: Document
    ) {}

    getActiveTheme() {
        const theme = this.themes.find(t => t.name === this.theme);
        if (!theme) {
            throw new Error(`Theme not found: '${this.theme}'`);
        }
        return theme;
    }

    setTheme(name: string) {
        if (name == 'dark') this.loadStyle('modal-dark.css');
        else this.loadStyle('modal-light.css');

        this.theme = name;
        this.themeChange.emit(this.getActiveTheme());
    }

    toggleDark() {
        if (this.getActiveTheme().name == 'dark') {
            this.setTheme(environment.theme);
            return environment.theme;
        } else {
            this.setTheme('dark');
            return 'dark';
        }
    }

    loadStyle(styleName: string) {
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            'client-theme'
        ) as HTMLLinkElement;
        if (themeLink) {
            themeLink.href = styleName;
        } else {
            const style = this.document.createElement('link');
            style.id = 'client-theme';
            style.rel = 'stylesheet';
            style.href = `${styleName}`;

            head.appendChild(style);
        }
    }
}
